import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import { useCallback, useState, useMemo } from 'react';
import { PlaceholderExtension, MentionAtomExtension, EmojiExtension, wysiwygPreset } from 'remirror/extensions';
import data from 'svgmoji/emoji.json';
import { TableExtension } from '@remirror/extension-react-tables';
import { useRemirror, ThemeProvider, Remirror, EditorComponent, EmojiPopupComponent, TableComponents, MentionAtomPopupComponent } from '@remirror/react';
import { AllStyledComponent } from '@remirror/styles/emotion';
import { T as TopToolbar, B as BubbleMenu } from '../../dist/top-toolbar-db3f0e96.browser.esm.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var _excluded = ["placeholder"];
var extraAttributes = [{
  identifiers: ['mention', 'emoji'],
  attributes: {
    role: {
      default: 'presentation'
    }
  }
}, {
  identifiers: ['mention'],
  attributes: {
    href: {
      default: null
    }
  }
}];

function MentionComponent(_ref) {
  var users = _ref.users,
      tags = _ref.tags;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      mentionState = _useState2[0],
      setMentionState = _useState2[1];

  var tagItems = useMemo(() => (tags !== null && tags !== void 0 ? tags : []).map(tag => ({
    id: tag,
    label: "#".concat(tag)
  })), [tags]);
  var items = useMemo(() => {
    var _mentionState$query$f;

    if (!mentionState) {
      return [];
    }

    var allItems = mentionState.name === 'at' ? users : tagItems;

    if (!allItems) {
      return [];
    }

    var query = (_mentionState$query$f = mentionState.query.full.toLowerCase()) !== null && _mentionState$query$f !== void 0 ? _mentionState$query$f : '';
    return allItems.filter(item => item.label.toLowerCase().includes(query)).sort();
  }, [mentionState, users, tagItems]);
  return /*#__PURE__*/jsx(MentionAtomPopupComponent, {
    onChange: setMentionState,
    items: items
  });
}

var SocialEditor = _ref2 => {
  var placeholder = _ref2.placeholder,
      props = _objectWithoutProperties(_ref2, _excluded);

  var extensions = useCallback(() => [new PlaceholderExtension({
    placeholder
  }), new TableExtension(), new MentionAtomExtension({
    matchers: [{
      name: 'at',
      char: '@',
      appendText: ' '
    }, {
      name: 'tag',
      char: '#',
      appendText: ' '
    }]
  }), new EmojiExtension({
    plainText: false,
    data,
    moji: 'noto'
  }), ...wysiwygPreset()], [placeholder]);
  var children = props.children;

  var _useRemirror = useRemirror({
    extensions,
    extraAttributes
  }),
      manager = _useRemirror.manager;

  return /*#__PURE__*/jsx(AllStyledComponent, {
    children: /*#__PURE__*/jsx(ThemeProvider, {
      children: /*#__PURE__*/jsxs(Remirror, {
        manager: manager,
        children: [/*#__PURE__*/jsx(TopToolbar, {}), /*#__PURE__*/jsx(EditorComponent, {}), /*#__PURE__*/jsx(EmojiPopupComponent, {}), /*#__PURE__*/jsx(MentionComponent, _objectSpread({}, props)), /*#__PURE__*/jsx(TableComponents, {}), /*#__PURE__*/jsx(BubbleMenu, {}), children]
      })
    })
  });
};

export { SocialEditor };
